import {ModalComponents} from 'constants/Modals';

import {useEffect} from 'react';

import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {deletePubBeerACS} from 'features/beersManager/requestAC';
import {setCheckedBeerAC, setRemovedBeerAC} from 'features/beersManager/slice';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {batch} from 'react-redux';
import {setModalAC} from 'store/modal/modalSlice';

import './ConfirmRemoveBeerFromTap.scss';

const ConfirmRemoveBeerFromTap = () => {
  const {checkedBeer} = useGlobalState((state) => state.beersManager);
  const {managedPub} = useGlobalState((state) => state.managedPub);
  const dispatch = useSetGlobalState();

  const handleCancel = () => {
    dispatch(setModalAC(null));
  };

  const handleRemovePubBeer = () => {
    if (managedPub && checkedBeer) {
      batch(() => {
        dispatch(deletePubBeerACS({pubId: managedPub.id, beerId: String(checkedBeer.id), name: checkedBeer.name}));
        dispatch(setModalAC(ModalComponents.REMOVE_BEER_SUCCESSFULLY));
        dispatch(setRemovedBeerAC(checkedBeer));
      });
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setCheckedBeerAC(null));
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="remove-beer-from-tap">
      <Text className="remove-beer-from-tap__title" tag="h3">
        Do you want to remove “{checkedBeer?.name}” from the list?
      </Text>
      <div className="remove-beer-from-tap__actions">
        <Button variant="text" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleRemovePubBeer}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default ConfirmRemoveBeerFromTap;
